export default __webpack_public_path__ + "static/media/service-home.d62ae669.webp";